<div class="container mt-5 mb-5 card p-3">
  <!-- Start Filter -->

  <div class="row">
    <div class="col-md-12">
      <h1 class="primary bold">
        <i class="fas fa-users"></i> {{ 'groupal-create' | translate }}
      </h1>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-12 pb-3">
      <h2 class="bold">{{ 'groupal-create-info' | translate }}</h2>
      <p class="pt-3">
        <i class="fas fa-info-circle primary"></i> {{ 'groupal-create-info2' | translate }}
      </p>
      <hr />
    </div>
  </div>
  <div class="container">
    <form class="form-grupal" [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <h2 class="primary">
            <i class="far fa-calendar-alt"></i> {{ 'info-group-class' | translate }} 
          </h2>
          <div class="mt-2 pb-1">
            <p>
              <strong>{{ 'write-group-name' | translate }}  </strong>{{ 'group-appears-list' | translate }} 
            </p>

            <input
              formControlName="name"
              type="text"
              class="form-control"
              placeholder="{{ 'group-class-name' | translate }} "
             
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mt-3">
          <p class="mt-4 bold">
            {{ 'write-group-class-description' | translate }} 
          </p>
          <textarea
            formControlName="description"
            rows="15"
            class="form-control"
            placeholder="{{ 'write-group-class-description' | translate }} "
          ></textarea>
        </div>
        <div class="col-md-6 pt-3">
          <p class="mt-4 pb-1 bold">
            {{ 'date' | translate }} <span class="label-no-change">*</span>
          </p>
          <input type="date" formControlName="date" class="form-control" />
          <p class="mt-4 pb-1 bold">
            {{ 'hour' | translate }} <span class="label-no-change">*</span>
          </p>
          <input type="time" formControlName="hour" class="form-control" />

          <p class="mt-4 pb-1 bold">
            {{ 'duration' | translate }} <span class="label-no-change">*</span>
          </p>
          <select class="form-control" formControlName="duration">
            <option value="1:00">1:00 h</option>
            <option value="1:15">1:15 h</option>
            <option value="1:30">1:30 h</option>
            <option value="1:45">1:45 h</option>
            <option value="2:00">2:00 h</option>
            <option value="2:15">2:15 h</option>
            <option value="2:30">2:30 h</option>
            <option value="2:45">2:45 h</option>
            <option value="3:00">3:00 h</option>
          </select>

          <p class="mt-4 pb-1 bold">
            {{ 'price-by-student' | translate }} <span class="label-no-change">* </span><span class="small">Min. 5,00 €</span>
          </p>
          <div class="input-group mb-3">
            <input
              formControlName="price"
              type="number"
              min="0"
              class="form-control"
              placeholder="10,00"
              aria-label="10,00"
              aria-describedby="basic-addon2"
            />
            <span class="input-group-text" id="basic-addon2">€</span>
          </div>

        </div>
      </div>
      <h2 class="mt-5 primary">{{ 'groupal-language-privacity' | translate }} </h2>
      <div class="row">
        <div class="col-md-6">
          <p class="mt-4 pb-1 bold">
            {{ 'groupal-select-language' | translate }}
            <span class="label-no-change">*</span>
          </p>
          <select class="form-control" formControlName="language_id">
            <option *ngFor="let langs of teacher_langs" [value]="langs.language.id">{{ langs.language.name }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <p class="mt-4 pb-1 bold">{{ 'groupal-select-privacity' | translate }} </p>
          <select class="form-control" formControlName="visibility">
            <option value="0" ngDefaultControl>
              {{ 'groupal-privacity-public' | translate }}
            </option>
            <option value="1">{{ 'groupal-privacity-private' | translate }}</option>
          </select>
        </div>
      </div>
      <h2 class="mt-5 primary">{{ 'groupal-select-subject-language' | translate }} <span class="label-no-change">*</span></h2>
      
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="legacy">
            <mat-select (selectionChange)="onChangeLesson($event)">
              <mat-option 
                *ngFor="let lesson of teacher_lessons" 
                [value]="lesson"
                >
                <span *ngIf="lesson.pivot.level_name">
                {{ lesson.name }} - {{ 'level' | translate }}: {{ lesson.pivot.level_name }}
              </span>
              <span *ngIf="!lesson.pivot.level_name">
                {{ lesson.name }} - {{ 'general-level' | translate }}
              </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <h2 class="mt-5 primary">{{ 'students' | translate }}</h2>
      <p></p>
      <div class="row">
        <div class="col-12">
          <div class="form-check pb-4 mt-3">
            <input
              formControlName="studentInvitation"
              class="form-check-input"
              type="radio"
              name="studentInvitation"
              value="0"
              checked
            />
            <label class="form-check-label">
              {{ 'groupal-no-send-invitations' | translate }} 
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-check pb-4 mt-3">
            <input
              formControlName="studentInvitation"
              class="form-check-input"
              type="radio"
              name="studentInvitation"
              value="1"
            />
            <label class="form-check-label">
              {{ 'groupal-send-invitations-all' | translate }}  
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-check pb-4 mt-3">
            <input
              formControlName="studentInvitation"
              class="form-check-input"
              type="radio"
              name="studentInvitation"
              value="2"
            />
            <label class="form-check-label">
              {{ 'groupal-send-invitations-manualy' | translate }}  
            </label>
          </div>

        </div>

      </div>




      <div *ngIf="showManualStudents" class="row p-3">

        <div class="col-md-12 border p-3 rounded-card bg-white">

          <div formArrayName="students" class="row p-3 gx-2">

            <div class="block" class="col-12">
              <h2 class=" pb-3 primary"><i class="fas fa-chalkboard-teacher"></i> <strong> {{ 'groupal-student-select' | translate }}   </strong></h2>
            </div>

            <div *ngIf="showAddStudent" class="margin-top-1 col-12">
              <button type="button" class=" btn btn-primary" (click)="addStudent()">
                <div class="flex-center">
                  <span class="margin-right-05">{{ 'groupal-add-student' | translate }}  </span>
                  <mat-icon svgIcon="plus"></mat-icon>
                </div>
              </button>
            </div>
    
            <div class="form-group col-md-3 p-2 teacher-materials-box" 
            *ngFor="let customStudent of studentsFormArray.controls; let index = index; let last = last; let first = first">

                    <div class="flex-end">
                      <button mat-icon-button (click)="removeStudent(index)">
                        <mat-icon>clear</mat-icon>
                      </button>
                    </div>
  
                    <div [formGroupName]="index">

                      <mat-form-field appearance="legacy">
                        <mat-label>{{ 'groupal-student-type' | translate }} </mat-label>
                        <mat-select class="form-control" (selectionChange)="onChangeTypeStudent($event, customStudent)" formControlName="typeStudent">
                          <mat-option value="myStudents">{{ 'groupal-my-students' | translate }} </mat-option>
                          <mat-option value="newStudent">{{ 'groupal-new-student' | translate }} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="(customStudent.controls.typeStudent?.invalid && customStudent.controls.typeStudent?.touched)">
                          {{'valid-input' | translate}}
                        </mat-error>
                      </mat-form-field>

                      <!-- selector de mis alumnos -->
                      <mat-form-field *ngIf="customStudent.controls.typeStudent.value == 'myStudents'" appearance="legacy">
                        <mat-label>{{'student' | translate}}</mat-label>
                        <mat-select class="form-control" (selectionChange)="onChangeStudent($event, customStudent)">
                          <mat-option [value]="student" *ngFor="let student of teacher_info.students">{{student.fullName}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="(customStudent.controls.typeStudent?.invalid && customStudent.controls.typeStudent?.touched)">
                          {{'valid-input' | translate}}
                        </mat-error>
                      </mat-form-field>

                      <!-- introducir nuevo alumno -->
                      <ng-container *ngIf="customStudent.controls.typeStudent.value == 'newStudent'">
                        <mat-form-field appearance="legacy">
                          <mat-label>{{'name' | translate}}</mat-label>
                          <input class="form-control" matInput type="text" formControlName="name">
                        </mat-form-field>
  
                        <mat-form-field appearance="legacy">
                          <mat-label>{{'email' | translate}}</mat-label>
                          <input class="form-control" matInput type="text" formControlName="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" name="email">
                        </mat-form-field>
                      </ng-container>
                     
                    </div>
                  </div>
          </div>
        </div>
      </div>
  

      <div class="row mt-5 pb-5 border-top">

        <div class="col-md-12 pt-3">
          <mat-checkbox class="acept-conditions" formControlName="conditions">
            {{'groupal-terms-conditions' | translate}} 
          </mat-checkbox>
        </div>

        <div class="col-md-6 pt-3">
          <button mat-raised-button color="primary" [disabled]="!validateform || loadingQuery" (click)="sendForm()">{{'groupal-create' | translate}} </button>
        </div>

        <div class="col-md-6 pt-3 flex-end">
          <button mat-raised-button color="warn" (click)="cancel()">{{'cancel' | translate}}</button>
        </div>


      </div>


    </form>
  </div>
</div>
